/**
 * Controlled notes textarea for the Candid patient-notes modal.
 *
 * @module patientNotesBody
 */
import { CandidNotesFormState } from "../../../data-model/candidNotesFormState";

/** Controlled props for {@link PatientNotesBody}. */
interface PatientNotesBodyProps {
  /** Current notes text owned by the parent modal. */
  value: CandidNotesFormState;
  /**
   * Emits the latest notes snapshot after every edit.
   *
   * @param state - Trimmed note text and whether Save may be enabled
   */
  onChange: (state: CandidNotesFormState) => void;
}

/**
 * Renders the Patient Notes textarea and forwards edits to the parent.
 *
 * @param props.value - Current notes snapshot
 * @param props.onChange - Parent setter for {@link CandidNotesFormState}
 * @returns The notes form body
 */
const PatientNotesBody = ({ value, onChange }: PatientNotesBodyProps) => {
  /**
   * Updates notes and validity from the textarea value.
   *
   * @param e - Native textarea change event
   */
  const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const notes = e.target.value;
    onChange({
      notes,
      isValid: notes.trim().length > 0,
    });
  };

  return (
    <div className="patient-notes-body--container flex flex-col gap-2">
      <div className="patient-notes-label text-tiny text-primaryGray-2">
        Patient Notes
      </div>
      <div className="patient-notes-textarea-wrap w-full">
        <textarea
          className="patient-notes-textarea"
          value={value.notes}
          onChange={handleNotesChange}
        />
      </div>
    </div>
  );
};

export default PatientNotesBody;
